import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuthHandling } from "./baseQuery";
import type {
  PerformanceFiguresResponse,
  PerformanceFiguresQuery,
} from "../types/performanceFigures";

function buildQuery(params: PerformanceFiguresQuery): string {
  const entries = Object.entries(params).filter(
    ([, v]) => v !== undefined && v !== "" && v !== 0,
  );
  if (entries.length === 0) return "/performance-figures";
  const qs = entries
    .map(([k, v]) => `${k}=${encodeURIComponent(String(v))}`)
    .join("&");
  return `/performance-figures?${qs}`;
}

export const performanceFiguresApi = createApi({
  reducerPath: "performanceFiguresApi",
  baseQuery: baseQueryWithAuthHandling,
  tagTypes: ["PerformanceFigures"],
  endpoints: (builder) => ({
    getPerformanceFigures: builder.query<
      PerformanceFiguresResponse,
      PerformanceFiguresQuery
    >({
      query: (params) => buildQuery(params),
      transformResponse: (raw: {
        status: string;
        data: PerformanceFiguresResponse;
      }) => raw.data,
      providesTags: ["PerformanceFigures"],
    }),
    syncPerformanceDaily: builder.mutation<
      unknown,
      { source?: "ALL" | "ESIGN" | "EKYC" } | void
    >({
      query: (body) => ({
        url: "/performance-ingestion/daily",
        method: "POST",
        body: body ?? {},
      }),
    }),
    syncPerformanceRange: builder.mutation<
      unknown,
      {
        source: "ALL" | "ESIGN" | "EKYC";
        fromDate: string;
        toDate: string;
        concurrency?: number;
        ekycChunkDays?: number;
      }
    >({
      query: (body) => ({
        url: "/performance-ingestion/range",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useGetPerformanceFiguresQuery,
  useSyncPerformanceRangeMutation,
} = performanceFiguresApi;
